import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const PUT_INITIALIZE_PERIOD_REQUEST = "PUT_INITIALIZE_PERIOD_REQUEST";
export const PUT_INITIALIZE_PERIOD_SUCCESS = "PUT_INITIALIZE_PERIOD_SUCCESS";
export const PUT_INITIALIZE_PERIOD_ERROR = "PUT_INITIALIZE_PERIOD_ERROR";

//* ACTIONS ------------------------------------------------
export const putInitializePeriodRequest = (payload = {}, callback) => ({
  type: PUT_INITIALIZE_PERIOD_REQUEST,
  payload,
  callback,
});

export const putInitializePeriodSuccess = () => ({
  type: PUT_INITIALIZE_PERIOD_SUCCESS,
});

export const putInitializePeriodError = (error) => ({
  type: PUT_INITIALIZE_PERIOD_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const putInitializePeriodServiceRequest = async (periodId) => {
  const options = await withToken({
    method: Methods.PUT,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/payrolls/periods/${periodId}/initialize`, options);
};
